import React from "react";
const SpoilerContainerIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "33", viewBox: "0 0 32 33", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinejoin: "round" }, /* @__PURE__ */ React.createElement("g", { stroke: "#FFF" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    strokeLinecap: "round",
    d: "M.874 11.54c-.498.808-.498 1.82 0 2.628 1.88 3.053 6.665 9.185 14.755 9.185s12.874-6.132 14.755-9.185c.498-.809.498-1.82 0-2.629-1.881-3.053-6.665-9.186-14.755-9.186S2.755 8.486.874 11.54z",
    transform: "translate(-618 -622) translate(618 622.5) translate(.5 3)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    strokeLinecap: "round",
    d: "M21.128 12.854c0 3.038-2.462 5.5-5.5 5.5-3.037 0-5.5-2.462-5.5-5.5s2.463-5.5 5.5-5.5c3.038 0 5.5 2.462 5.5 5.5z",
    transform: "translate(-618 -622) translate(618 622.5) translate(.5 3)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M28.128 25.354L3.128 0.353",
    transform: "translate(-618 -622) translate(618 622.5) translate(.5 3)"
  }
))))));
var SpoilerContainerIcon_default = SpoilerContainerIcon;
export {
  SpoilerContainerIcon_default as default
};
//# sourceMappingURL=SpoilerContainerIcon.js.map
